// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EpisodeDemographics_wrapper__2QKx-","container":"EpisodeDemographics_container__HNdt0"};